import React from 'react'
import Logo from "../assets/Icons/Frame 476.png";
import waitingGif from "../assets/gifs/waiting.gif";


const ApprovalModal = (props) => {

    if (!props.isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-[10%] flex items-center justify-center z-50 transition-opacity duration-300">
            <div className="bg-white rounded-xl p-8 text-center shadow-2xl w-[90%] max-w-md animate-fadeIn">
                <img src={props.data?.logo || Logo} alt="Logo" className="mx-auto mb-4 w-20" />
                <h2 className="text-xl font-bold mb-2">Waiting</h2>
                <img src={waitingGif} alt="Icon" className="mx-auto mb-4 w-[120px]" />
                <h3 className="text-lg font-semibold">{props.data?.name}</h3>
                <p className="text-sm text-gray-600">Waiting for Admin approval</p>
            </div>
        </div>
    );
};


export default ApprovalModal